const API_CONSTANT = {
	URL_TYPE: {
		MOCK: 'mock',
		POST_PE: 'postpe',
		POST_PE_V1: 'postpeV1',
		POST_PE_V2: 'postpeV2',
		CONSUMER: 'consumer',
		PAYMENT_V2: 'paymentV2',
		PAYMENT_V3: 'paymentV3',
		PAYMENT: 'payment',
		CARD: 'card',
		HANDSHAKE: 'handshake',
		BILL_PAYMENT: 'billPayment',
		DSA_LOAN: 'loans',
		ONDC: 'ondc',
	},
	URL: {
		HOME: 'account',
		SA_MIGRATE_LL: 'migrate/superapp',
		HOMEV2: 'credit-account',
		VALIDATE_PAN: 'validatePan',
		DEVICE_VERIFIED: 'update-device-verification',
		PAN_SAVE: 'panNumber',
		BANK_LIST: 'listbank',
		INIT_BANK_DETAILs: 'init-bank',
		VALIDATE_VPA: 'validate-vpa',
		INITIATE_PAYMENT: 'payment',
		TXN_STATUS: 'payment',
		TXN_LIST: 'account/txn/list',
		TXN_LIST_FILTERS: 'account/filters-list',
		FILTERED_TXN_LIST: 'account/filtered-txn/list',
		ACCOUNT_STATEMENT: 'account/statement',
		NON_BP_MERCHANT_INFO: 'NonBPMerchant/info',
		KYC_STATUS: 'kyc/status',
		INITIATE_REPAYMENT: 'bill/initiate',
		REPAYMENT_STATUS: 'bill/status',
		BILL_DETAILS: 'bill/billdetails',
		CARD_DETAILS_V1: 'user/card/detail',
		CARD_DETAILS_V2: 'v2/user/card/detail',
		ORDER_CARD_ADDRESS_DETAILS: 'user/card/order',
		CASHBACK_DETAILS: 'earnings',
		RATE_TXN: 'payment/review',
		APPRATE_TXN: 'review/v2',
		PREPAID_AGREEMENT: 'account/prepaid/agreement',
		PREPAID_ADD_MONEY: 'account/txn/add',
		PREPAID_TXN_STATUS: 'account/txn',
		PREPAID_TXN_LIST: 'prepaid/txn',
		PREPAID_INITIATE_PAYMENT: 'payment',
		ACCOUNT_SWITCH: 'account/switch',
		SEND_MONEY: 'sendMoney',
		VALIDATE_MOBILE: 'sendMoney/validate/mobile',
		SEND_MONEY_BANK_LIST: 'bank/details',
		SEND_MONEY_THROUGH_BANK: 'sendMoney/bankTransfer',
		INIT_SEND_MONEY_BANK_DETAILS: 'federal/init-bank-detail',
		INELIGIBLE_DETAILS: 'account/referralPosition',
		ACCOUNT_LIMIT: 'account/limit',
		POSTPE_CONTACT_LIST: 'referral/list',
		SEND_REFERRALS: 'addReferralList',
		LOAN_LIST: 'v1/loan-detail/loan-detail-list',
		LOAN_DETAIL: '/v1/loan-detail',
		REPAYMENT_HISTORY: 'bill/repayment/history',
		SANCTION_LETTER: '/sanction-letter',
		AGREEMENT: 'agreement/sanction',
		KFS_AGREEMENT: 'agreement/kfs-save',
		SANCTION_STATUS: 'agreement/sanction-letter/check/status',
		LOAN_AGREEMENT: 'agreement/tnc',
		COUNTER_SIGNED: 'agreement/docs',
		COACHMARKS_SHOWN: 'coachmark',
		BILL_HISTORY: '/bill/history',
		ZETA_CARD_LOGOUT_TRIGGLER: '/logoutTrigger',
		OGL: 'pincode/servicable/check',
		CREDIT_CARD_VALIDATE: '/credit-card/validate',
		CREDIT_CARD_LIST: '/cards',
		CREDIT_CARD_HISTORY: '/order/byCard/list',
		CREDIT_CARD_PAYMENT_LIST: '/order/list',
		CREDIT_CARD_INITIATE_PAYMENT: '/credit-card/initiate',
		CREDIT_CARD_ORDER_FULFILL: '/credit-card/fulfill',
		CREDIT_CARD_CREATE_ORDER: '/order/cardAuth',
		CREDIT_CARD_ORDER: '/order',
		CREDIT_CARD_BANK_DETAILS: '/credit-card/v2/bankDetails',
		CHECK_ORDER_STATUS: '/order/cardAuth/status/check',
		UPDATE_LIMIT: '/creditLimit/updated/details',
		UPDATE_LIMIT_FLAG: '/creditLimit/updated/shown',
		UPDATE_EMAIL: 'account/email',
		CHECK_LENDER_STATUS: '/check-status',
		DOWNLOAD_BILL_PDF: '/bill/bill-statement',
		ACCESS_FEATURE: '/account/feature-access',
		M2P_VIEW_CARD: 'm2p/view/virtual-card',
		M2P_PIN_SET: 'm2p/pin-set',
		M2P_CHANNEL_STATE: 'user/card/channel/state',
		M2P_LIMIT_UPDATE: 'user/card/limitSet',
		ADDRESS: 'address',
		LOAN_LETTER: 'agreement/loan-letter',
		FORECLOSURE_DETAILS: 'loan-detail/foreclose',
		ADDRESS_VALIDATE: 'address/validate',
		GET_PINCODE_DETAILS: 'getCityPincode',
		UNDERWRITING_ELIGIBLE: 'underwriting/eligible',
		UNDERWRITING_RERUN: 'underwriting/rerun',
		OFFER_LIST: '/offers',
		ALL_OFFER_LIST: '/offers/all',
		UPDATE_REFERENCE: 'v1/onboarding/consumer/contact-references',
		GET_REFERENCE: 'v1/account/onboarding/consumer/top/reference-candidates',
		ANNUAL_INCOME: '/onboarding/income',
		CONSENT: '/consent',
		PL_LIMIT: '/loan-details/personal-loan/limit',
		DSA_LOAN: '/loan-details-all',
		DSA_PREVALIDATION: 'cc/pre-validation',
		LOAN_CALCULATION: '/loan-details/personal-loan/calculation',
		VAS_PRODUCT: '/vas/suggested/products',
		/* Scratch Card */

		PVP_FLOW: {
			DEFAULT_BANK: '/ccbp/sm/bank',
			CREATE_ORDER: '/ccbp/sm/create',
			SM_ORDER: '/ccbp/sm/orders',
		},

		//T20
		SCRATCH_CARD: {
			T20: {
				INITIATE_PAYMENT: 't20/initiatePayment',
				GET_MATCH_DETAILS: 't20/getMatchDetails',
			},
		},
		SURVEY: '/survey',
		GENERATE_OTP: '/otp/generate',
		VERIFY_OTP: '/otp/verify',
		RESEND_OTP: '/otp/resend',
		UPDATE_ACCOUNT_STATUS: '/account/status',
		POSTPE_PAYMENT_MODES: '/account/payment-modes',
		ADDRESS_LIST: 'address/card',
		CHARGES: '/account/unbilled-charges',
		BILLS: {
			invoice: '/bill/bill-invoice',
		},
		LOAD_WALLET: '/wallet/load',
		WITHDRAW_WALLET: '/wallet/withdraw',
		LOAD_PAY_TXNS: 'wallet/txns',
		LOAD_PAY_TXNS_DETAILS: 'wallet/txn-details',
		APPLY_UNBILLED_CHARGES: 'account/unbilled-charges/apply',
		INITIATE_LENDER_UPGRADE: 'account/initiate-lender-upgrade',
		LENDER_UPGRADE_DETAILS: 'account/lender-upgrade/limit',
		TXN_CASHBACK_DETAILS: '/cashback/campaigns/v1/rewards?campaign=EXTERNAL_BILL_PAYMENT',
		SCRATCH_CARD_REWARD: '/cashback/campaigns/v1/scratch/reward',
		DSA_LOANS: {
			CREATE_LOANS: '/create-loan',
			PRE_VALIDATION: '/pre-validation',
			GENERATE_LEAD: '/generate-lead',
			CHECK_ELIGILIBILITY: '/check-eligibility',
			LOAN_DETAILS: '/loan-details-all',
		},
		CCBP_PENDING_ACTION_BANNER: '/v1/ccbp/sm/balance',
		CCBP_CARD_EXPIRY: '/cards/check-expiry',
	},
	QUERY_PARAMS: {
		INTENT: '?intent=',
		TXN_ID: '?txnId=',
		PAGE_NUM: '?page_num=',
		PAGE_SIZE: '&page_size=',
		ORDER_ID: '?orderId=',
		CALLBACK_URL: '?callbackUrl=',
		BANK_CODE: '?bankcode=',
		CAMEL_CASE_BANK_CODE: '?bankCode=',
		SECONDARY_TXN_ID: '&txnId=',
		BILL_ID: '?billId=',
		CHANNEL: '?channel=',
		ENABLED: '&enabled=',
		ACTIVATION_ENABLED: '?enabled=',
		TXN_CHANNEL: '&channel=',
		LIMIT_AMOUNT: '?amount=',
		LIMIT: '&limit=',
	},
	ONDC: {
		MAGICPIN: '/postpe-apps',
	},
	GIFT_VOUCHER: {
		GYFTR: '/postpe-apps',
	},
};
export default API_CONSTANT;
